import { useTranslation } from 'react-i18next';
import { cn } from 'lib/utils';
import { Switch } from 'components/ui/switch';
import { formatCredits } from 'features/usage/components/usage-credits';
import { teamsSwitchClassName, teamsSwitchThumbClassName } from './teams-styles';

type TeamsCreditAccessSwitchProps = {
  checked: boolean;
  memberName: string;
  creditsUsed: number | null;
  mutedColor: string;
  onCheckedChange: (checked: boolean) => void;
};

export function TeamsCreditAccessSwitch({
  checked,
  memberName,
  creditsUsed,
  mutedColor,
  onCheckedChange,
}: TeamsCreditAccessSwitchProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2">
      <Switch
        checked={checked}
        onCheckedChange={onCheckedChange}
        aria-label={t('TEAMS_CREDIT_ACCESS_FOR', {
          defaultValue: '{{name}} can use shared credits',
          name: memberName,
        })}
        className={teamsSwitchClassName}
        thumbClassName={teamsSwitchThumbClassName}
      />
      {checked && creditsUsed != null && (
        <span className={cn('whitespace-nowrap text-xs leading-heading', mutedColor)}>
          {formatCredits(creditsUsed)} {t('TEAMS_CREDITS_USED', { defaultValue: 'used' })}
        </span>
      )}
    </div>
  );
}
